export enum ERoles {
    ADMIN = 'ADMIN',
    SELLER_ADMIN = 'SELLER_ADMIN',
    DISTRIBUTOR = 'DISTRIBUTOR',
    SELLER_ONE = 'SELLER_ONE',
    SELLER_TWO = 'SELLER_TWO',
}
